import { useCallback, useEffect, useState } from 'react';
import { useAdminApi } from './admin-api-context.js';

export function useAdminQuery<T>(path: string, enabled = true) {
  const api = useAdminApi();
  const [data, setData] = useState<T>();
  const [error, setError] = useState<Error>();
  const [loading, setLoading] = useState(enabled);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(undefined);
    try {
      setData(await api.get<T>(path));
    } catch (caught) {
      setError(
        caught instanceof Error ? caught : new Error('The request failed'),
      );
    } finally {
      setLoading(false);
    }
  }, [api, path]);

  useEffect(() => {
    if (enabled) void refresh();
  }, [enabled, refresh]);

  return { data, error, loading, refresh };
}
